import { readLocalStorage, writeLocalStorage } from "./localStoragePreference.ts";

export type Language = "es" | "en";

const LOCAL_STORAGE_KEY = "evalhid-language";

/**
 * With nothing saved yet (first visit, or localStorage cleared): Spanish if
 * the browser is in Spanish (`es`, `es-ES`, `es-MX`...), English in any other
 * case — unlike theme.ts, here it does matter to start from the visitor's
 * real language instead of always assuming Spanish.
 */
function browserLanguage(): Language {
  return navigator.language.toLowerCase().startsWith("es") ? "es" : "en";
}

/** Once the user picks explicitly (see SettingsMenu.tsx), what's saved here takes precedence over the browser on any later visit. */
export function readSavedLanguage(): Language {
  const saved = readLocalStorage(LOCAL_STORAGE_KEY);
  if (saved === "es" || saved === "en") return saved;
  return browserLanguage();
}

export function saveLanguage(language: Language): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, language);
}
